import SVG, { SVGSizes } from "../core/SVG";
import { InputProps } from "./Input";

export type IconInputProps = InputProps & {
    svg?: string;
    svgSize?: SVGSizes;
    svgColor?: string;
    handleSubmit?: boolean;
    ToolTip?: string;
    id?: string;
};

const IconInput = ({
    value,
    handleChange,
    label,
    placeHolder,
    type = "text",
    loading = false,
    rounded = false,
    disabled = false,
    error,
    svg = "search",
    svgSize = 16,
    svgColor,
    handleSubmit = false,
    // ToolTip = "",
    id,
    className,
    style
}: IconInputProps) => {
    return (
        <div className={`field ${className}`} style={style}>
            {label ? <label>{label}</label> : ""}

            <div className={`control has-icon ${loading ? "is-loading" : ""}`}>
                <input
                    id={id}
                    type={type}
                    className={`input ${rounded ? "is-rounded" : ""}`}
                    onChange={(e) => handleChange(e)}
                    value={value}
                    placeholder={placeHolder}
                    disabled={disabled}
                />
                {handleSubmit ? (
                    <button
                        type="submit"
                        style={{ background: "none", border: "none" }}
                        className="form-icon"
                    >
                        <SVG svg={svg} size={svgSize} className={svgColor} />
                    </button>
                ) : (
                    <div className="form-icon">
                        <SVG svg={svg} size={svgSize} className={svgColor} />
                    </div>
                )}
                {/* <div className="form-icon">
                    <SVG svg={svg} size={svgSize} className={svgColor} />
                </div> */}
            </div>
            <p className={`field-error ${error ? "" : "is-hidden"}`}>{error}</p>
        </div>
    );
};

export default IconInput;
